import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import SvgIcon from '../Svg/SvgIcon';
import { SESSION_STORAGE_AMERICO_OBJECT_KEY, getSessionStorageItem } from '../../../sessionStorage';
import './ButtonCard.scss';

export default function ButtonCard(props) {

  const navigate = useNavigate();
  const color = props.color ? props.color : 'primary';

  const onProductClick = (url) => {
    if (url === '/landing/simplified-issue-term') {
      navigate('/landing/term-insurance', { state: { isFromSimplifiedIssueTerm: true } });
      return;
    }

    if (url === '/quote/term-life-insurance/loan-protector' || url === '/landing/loan-protector') {
      const sessionStorageData = getSessionStorageItem(SESSION_STORAGE_AMERICO_OBJECT_KEY);
      if (sessionStorageData) {
        sessionStorage.removeItem(SESSION_STORAGE_AMERICO_OBJECT_KEY);
        sessionStorage.removeItem('AMERICO_QUOTE');
      }
      url = 'landing/loan-protection';
    }
    navigate(url);
  }

  return (
    <div className={`button-card shadow-sm d-flex align-items-center tall ${color === 'primary' ? "primary-button" : ''}`}>
      <Button type="submit" onClick={() => onProductClick(props.href)} variant="contained" target={props.target} color={color} fullWidth ><span className="name"><SvgIcon iconName={props.icon} /><br />{props.name}{props.subtitle && (<span className="subtitle"><br />({props.subtitle})</span>)}</span></Button>
    </div>
  );
}

ButtonCard.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]),
  icon: PropTypes.string.isRequired,
  target: PropTypes.string,
  href: PropTypes.string,
}
